import React from 'react';
import Accordion from '~/common/components/Accordion';

import faqs from '~/common/utils/faqs';

// Import Local Styles
import styles from './faq.css';

const FAQ = () => (
    <div className={styles.wrapper}>
        <h1 className={styles.header}>
            Frequently Asked Questions
        </h1>
        <Accordion data={faqs} modifier={styles['content-wrapper']} />
    </div>
);

export default FAQ;
